export const shiftStatusColors = {
    waiting: "orange",
    approved: "green",
    rejected: "red",
    canceled: "red",
    deleted: "red"
};

export const shiftStatus = ["waiting", "approved", "rejected", "canceled", "deleted"];
